import { writable, get } from 'svelte/store'

export const searchQuery = writable(null)
export const searchResultPageNumber = writable(0)
export const searchResultSortOrder = writable('relevant')

export function updateUrlParams () {
  const parsedUrl = new URL(window.location.href)
  const urlParameters = parsedUrl.searchParams

  const urlSearchQuery = urlParameters.get('q')
  urlSearchQuery ? searchQuery.set(urlSearchQuery) : searchQuery.set(null)

  const urlPageNumber = urlParameters.get('page-number')
  urlPageNumber ? searchResultPageNumber.set(Number(urlPageNumber)) : searchResultPageNumber.set(0)

  const urlSortOrder = urlParameters.get('sort-order')
  urlSortOrder ? searchResultSortOrder.set(urlSortOrder) : searchResultSortOrder.set('relevant')
}

updateUrlParams()

export function updateQueryString () {
  console.log('updating query string...')
  const urlParameters = new URLSearchParams()

  // I cant subscribe here, so i have to 'get' it instead.
  const searchQueryValue = get(searchQuery)
  if (searchQueryValue) { urlParameters.set('q', searchQueryValue) }

  const searchPageNumberValue = get(searchResultPageNumber)
  if (searchPageNumberValue && searchPageNumberValue > 0) { urlParameters.set('page-number', searchPageNumberValue) }

  const searchResultSortOrderValue = get(searchResultSortOrder)
  console.log(searchResultSortOrderValue)
  if (searchResultSortOrderValue && searchResultSortOrderValue !== 'relevant') { urlParameters.set('sort-order', searchResultSortOrderValue) }

  const paramString = urlParameters.toString()
  if (paramString) {
    history.pushState(paramString, '', '/?' + paramString)
  }
}
